<template>
	<div class="popup-menu">
		<VButton
			:disabled="disableEdit"
			@click="editPerson"
		>
			<template #icon>
				<VIcon
					material="open_in_new"
					theme="outlined"
				/>
			</template>
			Открыть
		</VButton>

		<hr>

		<VButton
			@click="sendInvite(person)"
		>
			<template #icon>
				<VIcon
					material="send"
					theme="outlined"
				/>
			</template>
			Выслать приглашение
		</VButton>

		<VButton @click="deletePerson">
			<template #icon>
				<VIcon
					material="delete"
					theme="outlined"
				/>
			</template>
			Удалить
		</VButton>
	</div>
</template>

<script lang="ts">
import Person 				from "@/domains/Persons/Person";
import PersonsService from "@/domains/Persons/PersonsService";
import Core           from "@/core/Core";

export default defineComponent({
	name: "PersonContextMenu",

	props: {
		person: {
			type:    Person,
			default: null,
		},
		disableEdit: {
			type:    Boolean,
			default: false,
		},
	},

	data() {
		return {
			PersonsService,
		}
	},

	methods: {
		async sendInvite(person: Person) {
			this.$emit('hide');

			await PersonsService.sendInvite(person);

			this.$core.dialogs.PersonCard.hide();
		},

		async editPerson() {
			this.$emit('hide');

			await PersonsService.editPerson(
				this.person.id,
				() => {
					this.$emit(Person.Events.Updated)
					this.$core.dialogs.PersonCard.hide()
				})
		},

		async deletePerson() {
			this.$emit('hide');

			await PersonsService.deletePerson(
				this.person,
				() => this.$emit(Person.Events.Deleted))

			this.$core.dialogs.PersonCard.hide();
		},
	},
})
</script>
